export default __webpack_public_path__ + "static/media/body-section-triceps.e5a93e26.png";